/**
 * PocketFiler — Role-Based Access Control (Frontend)
 * 
 * Roles: owner > admin > member > viewer
 * Owner = !is_user (org creator)
 * Others stored in user.team_role
 */

const ROLE_HIERARCHY = {
  owner: 4,
  admin: 3,
  member: 2,
  viewer: 1,
};

/**
 * Get user's effective role
 */
export function getUserRole(user) {
  if (!user) return 'viewer';
  if (!user.is_user) return 'owner';
  return user.team_role || 'member';
}

/**
 * Check if user meets minimum role requirement
 */
export function hasMinRole(user, minimumRole) {
  const userRole = getUserRole(user);
  return (ROLE_HIERARCHY[userRole] || 0) >= (ROLE_HIERARCHY[minimumRole] || 0);
}

/**
 * Convenience checks
 */
export const canWrite = (user) => hasMinRole(user, 'member');       // create/edit deals, docs, etc.
export const canManageTeam = (user) => hasMinRole(user, 'admin');   // invite/remove, org settings
export const canManageBilling = (user) => hasMinRole(user, 'owner'); // billing, plan changes
export const isViewer = (user) => getUserRole(user) === 'viewer';
